// Suppresses noisy errors injected by browser wallet extensions (e.g. MetaMask).
// These originate from chrome-extension scripts, not from this app. We (1) swallow
// them at the window level (useful in production), and (2) in the dev preview,
// remove the webpack-dev-server error overlay ONLY when it is caused by such noise.

function isExtensionNoise(text) {
  const hay = (text || "").toLowerCase();
  return (
    hay.includes("metamask") ||
    hay.includes("chrome-extension://") ||
    hay.includes("moz-extension://") ||
    hay.includes("inpage.js")
  );
}

// (1) Window-level suppression (effective in production / for late listeners).
window.addEventListener(
  "error",
  (event) => {
    const src = event?.filename || "";
    const stack = event?.error?.stack || "";
    if (isExtensionNoise(`${event?.message} ${src} ${stack}`)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event?.reason;
    const msg = typeof reason === "string" ? reason : reason?.message;
    const stack = reason?.stack || "";
    if (isExtensionNoise(`${msg} ${stack}`)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

// (2) Dev-server overlay cleanup: remove the CRA overlay when it shows extension noise.
if (typeof MutationObserver !== "undefined") {
  const OVERLAY_ID = "webpack-dev-server-client-overlay";

  const readOverlayText = (host) => {
    // webpack-dev-server (CRA 5) renders the overlay inside a same-origin <iframe>,
    // older versions used a shadow root. Support both.
    try {
      if (host.shadowRoot && host.shadowRoot.textContent) return host.shadowRoot.textContent;
      if (host.contentDocument && host.contentDocument.body) {
        return host.contentDocument.body.textContent || "";
      }
    } catch {
      /* cross-origin or not ready */
    }
    return host.textContent || "";
  };

  const onlyExtensionNoise = (text) => {
    const entries = (text || "")
      .split(/ERROR/)
      .slice(1)
      .map((chunk) => chunk.trim())
      .filter((chunk) => chunk.length > 0);
    if (entries.length === 0) return false;
    return entries.every((entry) => isExtensionNoise(entry));
  };

  const inspectAndClean = () => {
    const host = document.getElementById(OVERLAY_ID);
    if (!host) return;
    const text = readOverlayText(host);
    if (onlyExtensionNoise(text)) {
      // Hide (don't remove) so webpack-dev-server can still reuse the node for
      // genuine app errors later in the session.
      host.style.setProperty("display", "none", "important");
      return;
    }
    if (text) {
      host.style.removeProperty("display");
    }
    if (!text && !host.dataset.extNoiseWatch) {
      // iframe content may not be ready yet; re-check shortly.
      host.dataset.extNoiseWatch = "1";
      const retry = (n) => {
        if (!document.getElementById(OVERLAY_ID)) return;
        inspectAndClean();
        if (n > 0) setTimeout(() => retry(n - 1), 100);
      };
      setTimeout(() => retry(10), 50);
    }
  };

  const start = () => {
    inspectAndClean();
    const observer = new MutationObserver(() => inspectAndClean());
    observer.observe(document.body, { childList: true, subtree: true });
    setInterval(inspectAndClean, 500);
  };

  if (document.body) start();
  else window.addEventListener("DOMContentLoaded", start);
}
